export default "__VITE_ASSET__DhnwxtiW__"